var render = function render(_c,_vm){return _c('div',[_c('div',[_vm._v(" "+_vm._s(_vm.parent.$d(_vm.$options.methods.convertDateWithTimeZone(_vm.props.date, _vm.props.offset), 'long'))+" ")]),(_vm.$options.methods.isShowingTimezone(_vm.props.offset))?_c('div',{staticClass:"grey--text"},[_vm._v(" "+_vm._s(_vm.$options.methods.getTimeZoneString(_vm.props.offset))+" ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }